export function errorText(error: unknown): string {
  if (typeof error === 'string') return error
  if (error instanceof Error) return `${error.name} ${error.message}`
  if (error && typeof error === 'object') {
    const record = error as { message?: unknown; code?: unknown }
    const parts = [record.message, record.code].filter((part) => typeof part === 'string')
    return parts.join(' ')
  }
  return ''
}

export function isClientNetworkFailure(error: unknown): boolean {
  const text = errorText(error)
  return (
    text.includes('NetworkError') ||
    text.includes('Failed to fetch') ||
    text.includes('Load failed')
  )
}

export function isStatementTimeout(error: unknown): boolean {
  const text = errorText(error)
  return text.includes('statement timeout') || text.includes('57014')
}

export function isDownloadRateLimited(error: unknown): boolean {
  return errorText(error).includes('Download increment failed: 429')
}

const reportedTransient = new Set<string>()

export function shouldReportTransientOnce(action: string, error: unknown): boolean {
  const key = `${action}:${errorText(error)}`
  if (reportedTransient.has(key)) return false
  reportedTransient.add(key)
  return true
}

export function __resetTransientReports(): void {
  reportedTransient.clear()
}
